export default __webpack_public_path__ + "static/media/other.01759be5.svg";